import React, { useEffect, useState } from "react";
import styles from "./DashLandlordListings.module.css";
import { useAuth } from "../../../contexts/AuthContext";
import axios from "axios";
import { Button, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
// import RentsByRealtor from "./ListingsByRealtor/RentsByRealtor/RentsByRealtor";
// import BuysByRealtor from "./ListingsByRealtor/BuysByRealtor/BuysByRealtor";
import { listingStates } from "../../../util/flStates";
import DashRentListings from "../dashboardUtil/DashRentListings/DashRentListings";
import DashSellListings from "../dashboardUtil/DashSellListings/DashSellListings";

import { toast } from "react-toastify";


function DashLandlordListings({ showErrorMessage, setPageLoading }) {
  const navigate = useNavigate();
  const { accessToken } = useAuth();
  const [listings, setListings] = useState([]);
  const [sellListings, setSellListings] = useState([]);
  const [rentListings, setRentListings] = useState([]);
  const [listingType, setListingType] = useState(listingStates.rent);

  const handleAddListing = () => {
    // alert("add lsiting");
    navigate(`/landlord`);
  };

  const sortListings = (listings) => {
    // Sort by created_at in descending order (latest first)
    const sortedListings = listings.sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );

    // Separate premium and normal properties
    const premiumProperties = sortedListings.filter(
      (listing) =>
        listing.is_premium === true && listing.landlord_id !== null
    );
    const normalProperties = sortedListings.filter(
      (listing) =>
        !(listing.is_premium === true && listing.landlord_id !== null)
    );

    // Concatenate normal properties first, followed by premium properties
    return [...premiumProperties, ...normalProperties];
  };

  const fetchListings = async () => {
    setPageLoading(true);
    try {
      // console.log("accessToken - first: ", accessToken);

      const response = await axios.get(
        `${import.meta.env.VITE_BACKEND_URL}/dash/landlord-listings`,
        {
          headers: {
            Authorization: accessToken,
          },
        }
      );

      // console.log("response: ", response);

      if (response.status === 200) {
        if (response.data.success) {
          setListings(response.data.listings || []);

          if (response.data.listings && response.data.listings.length) {
            // console.log()
            // console.log("listings count: ", response.data.listings.length);
            var liveRentListings = response.data.listings.filter(
              (listing) => listing.listing_type == listingStates.rent
            );
            var liveSellListings = response.data.listings.filter(
              (listing) => listing.listing_type == listingStates.sell
            );
            // console.log("liveRentListings: ", liveRentListings.length);
            // console.log("liveSellListings: ", liveSellListings.length);
            setRentListings(sortListings(liveRentListings) || []);

            setSellListings(sortListings(liveSellListings) || []);
          }
        } else {
          const errorMsg = response.data.message || "Error fetching listings.";
          showErrorMessage(errorMsg);
        }
      } else {
        const errorMsg = response.data.message || "Error fetching listings.";
        showErrorMessage(errorMsg);
      }
    } catch (error) {
      console.error("Error: ", error);
      showErrorMessage("Error fetching listings. Please try again!");
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    fetchListings();
  }, []);

  const handleRestore = async (listingId) => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/listings/restore/${listingId}`,
        {},
        {
          headers: { Authorization: accessToken },
        }
      );

      if (response.status === 200 && response.data.success) {
        try {
            const emailResponse = await axios.post(
              `${import.meta.env.VITE_BACKEND_URL}/listing/relist/send`,
              {
                listingId,
              },
              {
                headers: { Authorization: accessToken },
              }
            );

            if (emailResponse.status === 200 && emailResponse.data.success) {
              toast.success("Listing restored and email sent successfully!");
            } else {
              toast.warning("Listing restored, but failed to send email.");
            }
        } catch (error) {
          console.error("Restore error:", error);
          toast.error("An error occurred while sedning email confirmation for restoring the listing.");
        }
        // Send re-listing email
       
      } else {
        const errorMsg = response.data.message || "Failed to restore listing.";
        toast.error(errorMsg);
      }

      // Refresh listings
      fetchListings();
    } catch (error) {
      console.error("Restore error:", error);
      toast.error("An error occurred while restoring the listing.");
    }
  };


  return (
    <div className={styles.sectionContainer}>
      <h1 className={styles.mainTitle}>Manage Your Listings Here</h1>
      <div className={styles.addListingContainer}>
        <h1 style={{ color: "#1e40af", marginBottom: "3rem" }}>Add Your Listing Here</h1>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleAddListing}
        >
          Add Listing
        </Button>
        {/* <IconButton
          aria-label="bookmark Bahamas Islands"
          variant="plain"
          color="neutral"
          size="sm"
        >
          <AddIcon /> Add
        </IconButton> */}
      </div>
      <h1 style={{ marginBottom: "3rem" }}>View Your Listing</h1>
      <div className={styles.listingsWrapper}>
        {/* Active Listings Box */}
        {/* <div className={styles.listingBox}> */}
        <div>
          {listings && listings.length ? (
            <div>
              <div className={styles.rentSellSelectionContainer}>
                <div className={styles.rentSellSelectionBox}>
                  <Button
                    className={`${styles.rentSellSelectionOption} ${styles.rentSellSelectionOptionLeft}`}
                    variant={listingType === listingStates.rent ? "contained" : "outlined"}
                    onClick={() => setListingType(listingStates.rent)}
                  >
                    Rent
                  </Button>
                  <Button
                    className={`${styles.rentSellSelectionOption} ${styles.rentSellSelectionOptionRight}`}
                    variant={listingType === listingStates.sell ? "contained" : "outlined"}
                    onClick={() => setListingType(listingStates.sell)}
                  >
                    Sell
                  </Button>
                </div>
              </div>
              <div>
                {listingType === listingStates.rent ? (
                  <DashRentListings
                    passedListings={rentListings}
                    accessToken={accessToken}
                    handleRestore={handleRestore}
                    role="landlord"
                  />
                ) : listingType === listingStates.sell ? (
                  <DashSellListings
                    passedListings={sellListings}
                    accessToken={accessToken}
                    handleRestore={handleRestore}
                    role="landlord"
                  />
                ) : (
                  <div>No listing type found</div>
                )}
              </div>
            </div>
          ) : (
            <div>You do not have any listings yet. Start listing your properties now</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DashLandlordListings;
